/* 其他闲杂数据 */
export default {
  state: {
    logFileList: null, // 项目文件的附件数据
    cacheData: null, // 分页及查询条件的数据缓存
    childPagData: null, // 子页面分页及查询条件的数据缓存
    childPagDetailData: null, // 子页面详情列表分页及查询条件的数据缓存
  },
  mutations: {
    cacheData(state, val) {
      if(!state.cacheData && !val && localStorage.getItem('cacheData') != 'undefined'){
        state.cacheData = JSON.parse(localStorage.getItem('cacheData'))
        state.childPagData = JSON.parse(localStorage.getItem('childPagData')) || null
        state.childPagDetailData = JSON.parse(localStorage.getItem('childPagDetailData')) || null
      }else if(state.cacheData && !val){

      }else{
        state.cacheData = val
        state.childPagData = null
        localStorage.setItem('cacheData',JSON.stringify(val))
        localStorage.removeItem('childPagData')
      }
    },
    childPagData(state, val) {
      state.childPagData = val
      state.childPagDetailData = null
      localStorage.setItem('childPagData',JSON.stringify(val))
      localStorage.removeItem('childPagDetailData')
    },
    childPagDetailData(state, val) {
      state.childPagDetailData = val
      localStorage.setItem('childPagDetailData',JSON.stringify(val))
    }
  },
  actions: {

  },
  getters: {
    cacheData(state,data) {
      if(!state.cacheData && !localStorage.getItem('cacheData')){
        return false
      }else if(!state.cacheData && localStorage.getItem('cacheData')){
        return localStorage.getItem('cacheData')
      }else{
        return state.cacheData
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/other.js